import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Contract } from '../../../company/modules/contracts/models/contract.model';

@Component({
  selector: 'ag-contract-volume-pending[contract]',
  // standalone: true,
  // imports: [],
  templateUrl: './contract-volume-pending.component.html',
  styleUrl: './contract-volume-pending.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContractVolumePendingComponent implements OnInit {

  @Input() public contract: Contract;

  /** The language currently used. */
  public currentLang: string;

  constructor(
    private translateService: TranslateService
  ) { }

  /** @ignore */
  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang === 'es' ? undefined : this.translateService.currentLang;
  }
}
